<iframe class="w-full" [src]="iFrameURL" title="description" allow="camera;microphone"></iframe>